<template>
  <div id="add-item-to-basket-overlay"  class="AddToBasket-wrapper h-100 empty wrapper wrap-right" aria-hidden="true">
    <div id="modalWrapper" class="modal position-relative h-100 p-0">
      <div class="AddToBasket-preview d-flex flex-column flex-nowrap bg-white shadow w-100 modalBody" v-if="basketItem">
        <div class="external-menu-header bg-black d-flex modalHeader">
          <div class="d-flex title-section">
            <svg xmlns="http://www.w3.org/2000/svg" width="22.5" height="20" viewBox="0 0 22.5 20">
              <path id="shopping-cart-solid" d="M20.63,11.77l1.847-8.125A.938.938,0,0,0,21.562,2.5H6.219L5.861.75A.937.937,0,0,0,4.943,0H.938A.937.937,0,0,0,0,.938v.625A.937.937,0,0,0,.938,2.5h2.73L6.411,15.915a2.188,2.188,0,1,0,2.619.335H17.22a2.187,2.187,0,1,0,2.484-.406l.216-.948a.938.938,0,0,0-.914-1.145H8.52L8.265,12.5H19.716A.937.937,0,0,0,20.63,11.77Z" fill="#fff"/>
            </svg>
            <p class="f-light" style="margin-left: 20px;">{{ $translate("ETCeresCoconut::Template.singleItemAddToBasketHeadline") }}</p>
          </div>
          <button id="AddToBasketClose" type="button" class="close-modal-button" data-dismiss="modal">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 21.414 21.414">
              <g id="Gruppe_1210" data-name="Gruppe 1210" transform="translate(-209.793 -12.793)">
                <line id="Linie_51" data-name="Linie 51" x2="20" y2="20" transform="translate(210.5 13.5)" fill="none" stroke="#fff" stroke-width="2"/>
                <line id="Linie_52" data-name="Linie 52" y1="20" x2="20" transform="translate(210.5 13.5)" fill="none" stroke="#fff" stroke-width="2"/>
              </g>
            </svg>
          </button>
        </div>
        <div class="AddToBasket-addedItem d-flex p-0 bg-lightgrey">
          <div class="row is-table-row">
            <div class="add-item-to-basket-itemImage">
              <lazy-img class="img-fluid mx-auto"
                        :image-url="variation.images.all[0].urlPreview"
                        :alt="imageAlternativeText || itemName"
                        :title="itemName"/>
            </div>
            <div class="add-item-to-basket-itemData">
              <div class="m-0 p-0">
                <div class="AddItemName">{{ itemName }}</div>
                <span v-if="countAdditionalBasketItems > 0">{{ $translate("Ceres::Template.basketItemOverlayAdditionalCount", {"count": countAdditionalBasketItems }) }}<br /></span>
                {{ basketItem.quantity }} x {{ price | currency }}<br />
                <div  class="m-0 p-0" v-for="attribute in variation.attributes" :key="attribute.id">
                  {{ attribute.attribute.names.name }}: <span class="f-medium">{{ attribute.value.names.name }}</span><br />
                </div >
              </div>
              <template v-if="$store.getters.currentItemVariation.variation.id == basketItem.variationId">
                <template v-if="needSpecialAccessory">
                  <span class="add-item-info bg-etcRed">
                    {{ $translate("ETCeresCoconut::Template.singleItemAddToBasketInfoLeuchtmittelExklusive") }}
                  </span>
                </template>
              </template>
            </div>
          </div>
        </div>
        <div class="AddToBasket-content">
          <div class="AddToBasket-main">
            <template v-if="needSpecialAccessory">
              <div class="AddToBasket-InfoSection f-medium">
                  <template v-if="crossProducts.length > 0">
                    <template v-if="$store.getters.currentItemVariation.variation.id == basketItem.variationId">
                      <span>{{ $translate("ETCeresCoconut::Template.singleItemAddToBasketInfoLeuchtmittelCrossselling") }}</span>
                      <a id="AddToBasketLinkToCategory" :href="$translate('ETCeresCoconut::Template.singleItemAddToBasketLeuchtmittelCrosssellingCategoryUrl')" class="d-flex">
                        <span>{{ $translate("ETCeresCoconut::Template.singleItemAddToBasketInfoLeuchtmittelCrosssellingCategory") }}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6.069" height="10" viewBox="0 0 6.069 10" style="margin-left: 0.89289rem;">
                          <path id="chevron-right-solid" d="M33.4,43.046l-4.45,4.45a.55.55,0,0,1-.777,0l-.519-.519a.55.55,0,0,1,0-.776l3.527-3.544-3.527-3.544a.55.55,0,0,1,0-.776l.519-.519a.55.55,0,0,1,.777,0l4.45,4.45A.55.55,0,0,1,33.4,43.046Z" transform="translate(-27.495 -37.657)" fill="#464646"/>
                        </svg>
                      </a>
                    </template>
                  </template>
              </div>
              <div class="AddToBasket-cross-selling">
                <template v-if="$store.getters.currentItemVariation.variation.id == basketItem.variationId">
                  <template v-if="crossProducts.length > 0">
                    <div
                        class="crossselling-card d-flex"
                        v-for="item in crossProducts"
                        :key="item.id"
                    >
                      <div class="crossselling-thumb p-0 d-flex">
                        <a :href="item.data | itemURL(urlWithVariationId)" class="d-flex" style="position: relative;">
                          <div class="eek-img-section" v-if="eekImageUrl(item)" style="position: absolute; right:0; bottom:0;">
                            <lazy-img :image-url="eekImageUrl(item)" />
                          </div>
                          <lazy-img
                              :picture-class="'img-fluid'"
                              :image-url="item.data.images.all[0].urlSecondPreview"
                          />
                        </a>
                      </div>
                      <div class="crossselling-info d-flex p-0">
                        <div class="technical-data p-0" v-if="item.data.texts.technicalData" v-html="item.data.texts.technicalData"></div>
                        <div class="bg-lightgrey d-flex price-section">
                          <div class="p-0 prices">
                            <div class="price">
                              <p class="m-0 p-0 f-bold" style="line-height: 1.5rem">{{ item.data.prices.default.unitPrice.formatted}}</p>
                              <p class="m-0 p-0 f-light" style="font-size: 0.85717rem;line-height: 1.2857rem">{{ $translate("ETCeresCoconut::Template.singleItemAddToBasketLeuchtmittelCrosssellingTaxInfo") }}</p>
                            </div>
                          </div>
                          <div class="p-0 m-0">
                            <template v-if="needSpecialAccessory">
                              <div id="AddToBasketBtn" class="d-flex">
                                <add-to-basket
                                    data-testing="item-add-to-basket"
                                    :variation-id="item.id"
                                    :is-salable="true"
                                    :interval-quantity="neededQuantityAccessory || 1"
                                    :minimum-quantity="basketItem.quantity * Number(neededQuantityAccessory) || 1"
                                    :use-large-scale="false"
                                    :show-quantity="true"
                                >
                                </add-to-basket>
                                <svg xmlns="http://www.w3.org/2000/svg" width="6.069" height="10" viewBox="0 0 6.069 10" style="margin-left: 6px;">
                                  <path id="chevron-right-solid" d="M33.4,43.046l-4.45,4.45a.55.55,0,0,1-.777,0l-.519-.519a.55.55,0,0,1,0-.776l3.527-3.544-3.527-3.544a.55.55,0,0,1,0-.776l.519-.519a.55.55,0,0,1,.777,0l4.45,4.45A.55.55,0,0,1,33.4,43.046Z" transform="translate(-27.495 -37.657)" fill="#464646"/>
                                </svg>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </div>
            </template>
          </div>
          <div class="AddToBasket-footer d-flex bg-lightgrey">
            <div class="AddToBasket-Buttons d-flex">
              <a v-waiting-animation-infinite :href="urls.basket" rel="nofollow" class="btn btn-secondary position-relative">
                {{ $translate("Ceres::Template.singleItemBasket") }}
                <svg xmlns="http://www.w3.org/2000/svg" width="16.875" height="15" viewBox="0 0 16.875 15" class="position-absolute">
                  <path id="shopping-cart-solid" d="M15.472,8.828l1.385-6.094a.7.7,0,0,0-.686-.859H4.664L4.4.562A.7.7,0,0,0,3.707,0H.7A.7.7,0,0,0,0,.7v.469a.7.7,0,0,0,.7.7H2.75L4.809,11.937a1.641,1.641,0,1,0,1.964.251h6.142a1.64,1.64,0,1,0,1.863-.3l.162-.711a.7.7,0,0,0-.686-.859H6.39L6.2,9.375h8.588A.7.7,0,0,0,15.472,8.828Z" fill="#fff"></path>
                </svg>
              </a>
              <a v-waiting-animation-infinite :href="urls.checkout" rel="nofollow" class="btn btn-primary">
                {{ $translate("Ceres::Template.singleItemCheckout") }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="AddToBasketOverlay" class="AddToBasket-overlay overlay" @click="handleOverlayClick"></div>
  </div>
</template>

<script>
import { isNullOrUndefined } from "../../helper/utils";
import { mapState } from "vuex";
import OrderPropertyValueList from "../item/OrderPropertyValueList.vue";

const ModalService  = require("../../services/ModalService");
const ApiService    = require("../../services/ApiService");
export default {
  name: "add-item-to-basket-overlay",

  components: {
    OrderPropertyValueList,
  },

  props: {
    defaultTimeToClose: {
      type: Number,
      default: 15,
    },
    crossProducts: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      price: 0,
      basketItem: null,
      countAdditionalBasketItems: 0,
      neededQuantityAccessory: 1,
    };
  },

  mounted()
  {
    if (App.config.basket.addItemToBasketConfirm === "overlay")
    {
      ApiService.listen("AfterBasketItemUpdate", data =>
      {
        const updatedBasketItem = data.basketItems[0];

        if (!this.isBasketItemQuantityUpdate)
        {
          const basketItem = this.basketItems.find(item => item.id === updatedBasketItem.id) || {};
          this.updateNeededQuantityAccessory();
          this.showItem(basketItem);
        }
      });

      ApiService.listen("AfterBasketItemAdd", data =>
      {
        this.updateNeededQuantityAccessory();
        this.showItem(data.basketItems[0], data.basketItems.length - 1);
      });
    }
  },
  watch: {
    variation: {
      immediate: true,
      handler() {
        this.updateNeededQuantityAccessory();
      },
    },
  },
  computed: {
    ...mapState({
      basketItems: (state) => state.basket.items,
      isBasketItemQuantityUpdate: (state) => state.basket.isBasketItemQuantityUpdate,
    }),

    isLastBasketEntrySet()
    {
      return !isNullOrUndefined(this.basketItem);
    },

    variation() {
      return this.basketItem?.variation?.data || null;
    },

    itemName() {
      return this.isLastBasketEntrySet ? this.$options.filters.itemName(this.variation) : "";
    },

    imageUrl()
    {
      if (this.isLastBasketEntrySet)
      {
        const images = this.$options.filters.itemImages(this.variation.images, "urlPreview");

        return this.$options.filters.itemImage(images);
      }

      return "";
    },

    imageAlternativeText()
    {
      if (this.isLastBasketEntrySet)
      {
        const images = this.$options.filters.itemImages(this.variation.images, "urlPreview");

        return this.$options.filters.itemImageAlternativeText(images);
      }

      return "";
    },

    urls() {
      return {
        basket: App.urls.basket,
        checkout: App.urls.checkout,
      };
    },
    urlWithVariationId() {
      return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
    },
    needSpecialAccessory() {
      if (!this.variation || !this.variation.variationProperties) return false;

      const relevantProperty = this.getRelevantProperty(242);
      if (!relevantProperty || !relevantProperty.values) return false;
      return relevantProperty.values.selectionId === 1704;
    }
  },

  methods: {
    showItem(basketItem, countAdditionalBasketItems)
    {
      this.basketItem = basketItem;
      this.countAdditionalBasketItems = countAdditionalBasketItems;
      this.price = basketItem.price;

      ModalService
          .findModal(document.getElementById("add-item-to-basket-overlay"))
          .setTimeout(this.defaultTimeToClose * 1000)
          .show();
    },
    closeModal() {
      this.basketItem = null;
    },
    getItemUrl(item) {
      return item.data.variation.id;
    },
    handleOverlayClick() {
      // Modal schließen
      this.closeModal();

      // Änderungen am <body>-Tag
      const body = document.body;
      if (body.classList.contains("modal-open")) {
        body.classList.remove("modal-open");
      }
      body.style.paddingRight = "";

      // Änderungen am <header>-Tag
      const header = document.querySelector("header");
      if (header) {
        header.style.paddingRight = "";
      }

      // Änderungen am Modal-Wrapper
      const modalWrapper = document.querySelector(".add-item-to-basket-overlay #modalWrapper");
      if (modalWrapper) {
        modalWrapper.setAttribute("aria-hidden", "true");
        modalWrapper.removeAttribute("aria-modal");

        if (modalWrapper.classList.contains("show")) {
          modalWrapper.classList.remove("show");
        }

        modalWrapper.style.display = "none";
        modalWrapper.style.paddingRight = "";
      }
    },
    getRelevantProperty(id) {
      if (!this.variation || !this.variation.variationProperties) return null;

      for (const group of this.variation.variationProperties) {
        for (const property of group.properties) {
          if (property.id === id) {
            return property;
          }
        }
      }
      return null;
    },

    updateNeededQuantityAccessory() {
      this.neededQuantityAccessory = this.quantityOfAccessory();
    },
    quantityOfAccessory() {
      if (!this.variation || !this.variation.variationProperties) return 1;

      const relevantProperty = this.getRelevantProperty(282);
      if (!relevantProperty) return 1;

      const value = relevantProperty.values?.value;
      return !isNaN(Number(value)) ? Number(value) : 1; // Rückgabe als gültige Zahl
    },


    eekImageUrl(crossItem) {
      if (!crossItem) return null;
      const propertyId = 172;
      // Durchlaufe die PropertyGroups (variationProperties)
      const relevantPropertyGroup = crossItem.data?.variationProperties?.find(
          (group) =>
              group.properties?.some(
                  (property) => property.id === propertyId && property.values?.value
              )
      );

      // Hole die Eigenschaft mit der ID 172 aus der gefundenen Gruppe
      const relevantProperty = relevantPropertyGroup?.properties?.find(
          (property) => property.id === propertyId && property.values?.value
      );

      // Gib die URL zurück, falls ein relevanter Wert gefunden wurde
      return relevantProperty
          ? `https://cdn02.plentymarkets.com/9krpwzxa6mmo/frontend/shop_res/items/eek/${relevantProperty.values.value.toLowerCase()}-links.svg`
          : null;
    }
  },
};
</script>
